import * as React from 'react'
import type { PasswordStrength } from 'types/business'
import { getPasswordStrengthMinimumChars } from '@disco/utils/password'
import TextField from 'components/ui/text-field'
import { useTranslation } from '@disco/i18n/use-translation'
type Props = {
  passwordStrength: PasswordStrength
  password: string
  passwordChangeInProgress?: boolean
  onPasswordChange: (...args: Array<any>) => any
  errors: Record<string, React.ReactNode | null | undefined>
}

/**
 * Password change form for user invitations with minimal validation
 * Simple form with single password field for initial account setup
 * @param passwordStrength - Business password strength requirements
 * @param password - Current password value
 * @param passwordChangeInProgress - Whether password change is in progress
 * @param onPasswordChange - Callback when password input changes
 * @param errors - Error messages for form validation
 */
const ChangePasswordInvitesForm = (props: Props): React.ReactElement<'div'> => {
  const { t } = useTranslation('accounts')
  const passwordMinChars = getPasswordStrengthMinimumChars(
    props.passwordStrength,
  )
  return (
    <div className="ChangePasswordDialog">
      <TextField
        type="password"
        autoComplete="new-password"
        placeholder={t(
          'accounts:passwordAtLeastCharsCharacters',
          'Password (at least {{chars}} characters)',
          { chars: passwordMinChars },
        )}
        onChange={props.onPasswordChange}
        value={props.password}
        invalid={!!props.errors['new-password']}
        error={props.errors['new-password']}
      />
    </div>
  )
}

export default ChangePasswordInvitesForm
